/* eslint-disable */
<template>
  <b-container fluid class="landing-wrapper">
 

<section id="landing-st">

<h1>Safety Training Instructor Training Portal</h1>
<b-button :to="'/' + $router.currentRoute.params.lang + '/auth'"  class='mmm-button'>{{ $t('landing.beginbutton') }}<hr class='mmm-bar main-gradient'/><hr class='white-bar'/></b-button>

<!-- <div class="column">
    <button @click="update('https://instructor.branton.io/server/public/uploads/fivepoint/1665876128.zip')">DOWNLOAD</button> &nbsp;
    <button @click="extraction()">UNZIP</button> &nbsp;
    <button @click="serve('1665876128')">SERVE</button> &nbsp;

    <iframe
            :src="source"
            allowfullscreen
            frameborder="0" >
           </iframe>
  </div> -->


</section>
  
  </b-container>
</template>

<script>
  import { getHeader } from '../headers.js';


export default {

    name: 'hello',

    data() {
      return {
        source: ''
      }
    },
    mounted() {
},

methods : {
  async update(url){
      try {
        //We can process here the correct URL path for the ZIP download as well as credential authentication via API
        await window.file.runme(url);
        } catch (e) {
          console.log(`Failed to save the file ${e}!`);
        }
      // let userPath = await window.file.userPath();
      // console.log(userPath);

    },
    async extraction(){
      try {
        let zipfile = '1665876128.zip';
        await window.file.unzip(zipfile);
        } catch (e) {
          console.log(`Failed to unzip the file ${e}!`);
        }
    },
    async serve(code){
      try {
      //     // window.file.save('public/myfile.txt', 'the text to write to the file overwrite it now!');
          let vm = this;
          let userPath = await window.file.userPath();
          // let filepath = 'file:' + userPath + '/extractions/' + code + '.html';    
          // vm.source = filepath;
        } catch (e) {
          console.log(`Failed to serve the file ${e}!`);
        }
      
    }
},
created() {
  },

watch: {

  },

  }

</script>

<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.landing-wrapper {
    background-image: url('~@/assets/repeatgrid2.svg');
    background-size: cover;
    min-height:100vh;
}
iframe {
    width: 100%;
    min-height: 330px;
}

</style>
